/* ==================================================================
   ASSOCHAM · SECTOR PAGE — DATA
   Sections: Overview · Councils · Publications · Press Release ·
             Press Coverage · Events
================================================================== */

export const IMAGES = {
  hero: "https://images.pexels.com/photos/20445169/pexels-photo-20445169.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=900&w=1600",
  field:
    "https://images.pexels.com/photos/34479827/pexels-photo-34479827.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=800&w=1200",
  sower:
    "https://images.pexels.com/photos/26762735/pexels-photo-26762735.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=800&w=1200",
};

export const SECTION_NAV = [
  { id: "overview", label: "Overview" },
  { id: "councils", label: "Councils" },
  { id: "publications", label: "Publications" },
  { id: "press", label: "Press" },
  { id: "events", label: "Events" },
];

/* ------------------------------ OVERVIEW ------------------------------ */

/* Complete official overview copy — verbatim */
export const OVERVIEW_PARAGRAPHS = [
  "ASSOCHAM as a premier industry body is playing a significant role in promulgating Agriculture sector via modern and traditional channels.",
  "The various stakeholders which are directly or indirectly involved in the council include — Ministry of Agriculture and Farmers' Welfare, Ministry of Fisheries, Animal Husbandry and Dairying, Ministry of Jal Shakti, Ministry of Chemical and Fertilizers, SFAC, APEDA, NDDB, ICAR, CSIR, NCCD, MPEDA etc.",
  "The core functions of Agriculture Council include Public policy advocacy, Promotion of innovation, Training and Research Programmes, Exhibitions, Conferences along with organising workshops, training programmes, panel discussions, round-table meetings etc.",
];

export const OVERVIEW_STATS = [
  { value: "40%", label: "of India's population dependent on agriculture" },
  { value: "3rd", label: "India's global rank in agricultural output" },
  { value: "200+", label: "stakeholders convened at AgriBiz Connect 2025" },
  { value: "86%", label: "farmers to benefit from unified agri-tech" },
];

export const STAKEHOLDERS = [
  { short: "MoA&FW", name: "Ministry of Agriculture and Farmers' Welfare" },
  { short: "MoFAHD", name: "Ministry of Fisheries, Animal Husbandry and Dairying" },
  { short: "MoJS", name: "Ministry of Jal Shakti" },
  { short: "MoC&F", name: "Ministry of Chemical and Fertilizers" },
  { short: "SFAC", name: "Small Farmers Agribusiness Consortium" },
  { short: "APEDA", name: "Agricultural & Processed Food Products Export Development Authority" },
  { short: "NDDB", name: "National Dairy Development Board" },
  { short: "ICAR", name: "Indian Council of Agricultural Research" },
  { short: "CSIR", name: "Council of Scientific & Industrial Research" },
  { short: "NCCD", name: "National Centre for Cold-chain Development" },
  { short: "MPEDA", name: "Marine Products Export Development Authority" },
];

export const CORE_FUNCTIONS = [
  {
    icon: "policy",
    title: "Public Policy Advocacy",
    text: "Carrying industry-validated recommendations to ministries, regulators and parliamentary committees.",
  },
  {
    icon: "bulb",
    title: "Promotion of Innovation",
    text: "Championing agri-tech, precision farming and R&D partnerships between industry, academia and startups.",
  },
  {
    icon: "book",
    title: "Training & Research Programmes",
    text: "Capacity building, field research and knowledge dissemination for sustainable agriculture.",
  },
  {
    icon: "globe",
    title: "Exhibitions & Conferences",
    text: "National summits, trade fairs and expositions connecting the entire agri value chain.",
  },
  {
    icon: "chat",
    title: "Workshops & Panel Discussions",
    text: "Seminars, panel discussions and skilling workshops on pressing issues facing Indian agriculture.",
  },
  {
    icon: "users",
    title: "Round-Table Meetings",
    text: "Closed-door consultations that bring government, industry and research bodies to one table.",
  },
];

/* ------------------------------ COUNCILS ------------------------------ */

export const COUNCIL_MEMBERS = [
  {
    name: "Jaidev R Shroff",
    role: "Council Chair",
    designation: "Global CEO, UPL Limited",
    photo: "https://assocham.org/assets/images/sector_council/Jai-Shroff%20.jpg",
    initials: "JS",
  },
  {
    name: "N K Aggarwal",
    role: "Council Co-Chair",
    designation: "Chairman, Crystal Crop Protection Limited",
    photo:
      "https://assocham.org/assets/images/sector_council/1720685263_Mr.%20N%20K%20Aggarwal.png",
    initials: "NA",
  },
];

export const COUNCIL_MANDATE = [
  "Convene industry, government, research bodies and farmer organisations on one table",
  "Build evidence with knowledge partners into actionable position papers",
  "Advocate reform through memoranda, consultations and task forces",
  "Deploy pilots, training and technology down to the last farm",
];

/* ---------------------------- PUBLICATIONS ---------------------------- */

export const PUBLICATIONS = [
  {
    date: "October 2024",
    partner: "With EY LLP",
    title: "Agri-tech Adoption for Climate-Resilient Agriculture in India",
    text: "A strategic roadmap for prioritizing climate-resilient practices and bridging the tech divide for 86% of Indian farmers.",
    pages: "68 pages",
  },
  {
    date: "2024",
    partner: "Knowledge Partner",
    title: "Precision Farming: Scaling Sustainable Growth",
    text: "Policy recommendations on crop insurance, bio-CNG, ethanol production, and converting agricultural waste into energy.",
    pages: "52 pages",
  },
  {
    date: "2025",
    partner: "Research Report",
    title: "Horticulture-Led Growth for Farmer Incomes",
    text: "Analysis of horticulture as a strategic lever for enhancing farmer incomes, food security, and rural employment.",
    pages: "44 pages",
  },
];

/* ------------------- PRESS RELEASES / PRESS COVERAGE ------------------- */

export const PRESS_RELEASES = [
  {
    date: "2026-07-09",
    title:
      "Innovation, Global Collaboration and Climate-Positive Growth Define ASSOCHAM's 2026 Agenda",
    excerpt:
      "Innovation-led research, science-based regulatory frameworks and deepened global partnerships headline the chamber's agenda for building a climate-positive, future-ready Indian economy.",
    tags: ["Innovation", "Climate change policy"],
  },
  {
    date: "2026-07-09",
    title:
      "Agri Council calls for apprenticeship-embedded curricula at National Skills Summit",
    excerpt:
      "Stressing that education must go beyond imparting degrees, ASSOCHAM called for closer university-industry pipelines that make every agri learner employable.",
    tags: ["Education and skills", "Employment"],
  },
  {
    date: "2026-07-03",
    title:
      "ASSOCHAM urges rationalised GST on farm machinery to accelerate mechanisation",
    excerpt:
      "The Agriculture & Food Processing Council submitted a pre-budget memorandum seeking input-cost relief, custom hiring incentives and faster depreciation for farm equipment.",
    tags: ["Taxation", "Farm mechanisation"],
  },
  {
    date: "2026-05-21",
    title:
      "Council releases 10-point charter for climate-resilient cropping systems",
    excerpt:
      "The charter maps drought-tolerant varieties, micro-irrigation targets and a carbon-credit framework for smallholder farmers across 12 agro-climatic zones.",
    tags: ["Sustainability", "Water management"],
  },
];

export const PRESS_COVERAGE = [
  {
    date: "2026-07-11",
    source: "The Economic Times",
    title:
      "Indian agri-tech needs a unified data backbone, says ASSOCHAM council chair",
    excerpt:
      "Industry leaders at the chamber's agri roundtable pushed for interoperable farm data standards linking advisory, credit and insurance in one stack.",
    tags: ["Agri-tech", "Interview"],
  },
  {
    date: "2026-06-28",
    source: "Business Standard",
    title:
      "Food processing capacity to double by 2030 on cold-chain push: industry body",
    excerpt:
      "Citing ASSOCHAM estimates, the report notes mega food parks and rural cold storage as the biggest levers for reducing post-harvest losses.",
    tags: ["Food processing", "Investment"],
  },
  {
    date: "2026-06-14",
    source: "Mint",
    title: "Kisan drones move from pilot to scale across 12 states",
    excerpt:
      "Coverage of the council's drone deployment review highlights spraying economics, operator training and the emerging custom-hiring model.",
    tags: ["Drones", "Precision farming"],
  },
  {
    date: "2026-04-30",
    source: "The Hindu BusinessLine",
    title: "Natural farming workshops train over 5,000 farmers in FY 2024-25",
    excerpt:
      "Field reportage on the ASSOCHAM–ICAR workshop series covering zero-budget natural farming, certification and market linkage for organic produce.",
    tags: ["Natural farming", "Training"],
  },
];

/* -------------------------------- EVENTS -------------------------------- */

export const EVENTS = [
  // ==================== FORTHCOMING EVENTS ====================
  {
    title: "National Agri-Tech Summit 2026",
    type: "forthcoming",
    tag: "Summit",
    date: "15-16 January 2026",
    place: "New Delhi",
    text: "India's premier agri-technology summit bringing together policymakers, industry leaders, and innovators to shape the future of digital agriculture and smart farming solutions.",
    highlight: "Expected 500+ participants including 50 international delegates and 100+ startups"
  },
  {
    title: "Farmers' Digital Empowerment Conclave",
    type: "forthcoming",
    tag: "Conclave",
    date: "22-23 February 2026",
    place: "Jaipur, Rajasthan",
    text: "A two-day conclave focused on bridging the digital divide in agriculture, featuring hands-on workshops on digital tools, e-NAM platform, and agri-fintech solutions for smallholder farmers.",
    highlight: "Free digital literacy training for 1000+ farmers from 10 districts"
  },
  {
    title: "International Food Processing Expo 2026",
    type: "forthcoming",
    tag: "Exhibition",
    date: "5-7 March 2026",
    place: "Mumbai, Maharashtra",
    text: "Asia's largest food processing exhibition showcasing cutting-edge technologies, cold chain solutions, and value addition techniques. Features B2B meetings and investment roundtables.",
    highlight: "300+ exhibitors from 20 countries | Expected footfall: 50,000+"
  },
  {
    title: "Sustainable Agriculture Roundtable",
    type: "forthcoming",
    tag: "Roundtable",
    date: "18 April 2026",
    place: "Bengaluru, Karnataka",
    text: "High-level policy roundtable on sustainable agriculture practices, carbon credits for farmers, and climate-resilient farming. Jointly organized with NITI Aayog and ICAR.",
    highlight: "Closed-door session with Union Agriculture Minister and 25 industry CEOs"
  },
  {
    title: "Agri-Startup Pitch Fest 2026",
    type: "forthcoming",
    tag: "Competition",
    date: "10-11 May 2026",
    place: "Hyderabad, Telangana",
    text: "India's biggest agri-startup competition where 50 shortlisted startups pitch to VCs, angel investors, and corporate leaders. Prizes worth ₹2 Crore including incubation support.",
    highlight: "Grand prize: ₹50 Lakhs seed funding + 6 months mentorship at ICRISAT"
  },
  {
    title: "Organic Farming & Export Conclave",
    type: "forthcoming",
    tag: "Conclave",
    date: "20-21 June 2026",
    place: "Kochi, Kerala",
    text: "Focused on organic certification, export opportunities, and value chain development for organic produce. Includes sessions on spice exports, coconut products, and marine exports.",
    highlight: "Buyer-seller meet with 100+ international buyers from EU, US, and Middle East"
  },
  {
    title: "Precision Agriculture Workshop Series",
    type: "forthcoming",
    tag: "Workshop",
    date: "July-August 2026",
    place: "Multiple Cities (Pune, Ludhiana, Coimbatore)",
    text: "A series of hands-on workshops on drone technology, IoT sensors, AI-based crop monitoring, and precision irrigation systems for progressive farmers and FPOs.",
    highlight: "Live demonstrations on 50 acres across 3 states | 2000 farmers to be trained"
  },

  // ==================== PAST EVENTS ====================
  {
    title: "Kharif Outlook Conference 2025",
    type: "past",
    tag: "Conference",
    date: "12 June 2025",
    place: "New Delhi",
    text: "Annual flagship conference on Kharif crop outlook with presentations from IMD, Ministry of Agriculture, and leading agri-economists. Covered monsoon predictions, input costs, and market trends.",
    highlight: "300+ attendees | Policy recommendations submitted to PMO"
  },
  {
    title: "Farmers' Producer Organization (FPO) Summit",
    type: "past",
    tag: "Summit",
    date: "8-9 August 2025",
    place: "Lucknow, Uttar Pradesh",
    text: "Two-day summit connecting 200+ FPOs with processors, exporters, and retailers. Covered topics on collective marketing, access to credit, and FPO governance models.",
    highlight: "50+ MoUs signed between FPOs and corporate buyers worth ₹150 Crore"
  },
  {
    title: "World Food India 2025 - ASSOCHAM Pavilion",
    type: "past",
    tag: "Exhibition",
    date: "19-22 September 2025",
    place: "Pragati Maidan, New Delhi",
    text: "ASSOCHAM hosted a dedicated pavilion at World Food India 2025 showcasing innovations in food processing, millet-based products, and sustainable packaging solutions from 40 member companies.",
    highlight: "Pavilion visited by PM Modi | 10,000+ business visitors | Investment commitments of ₹500 Crore"
  },
  {
    title: "Rabi Preparedness & Input Management Seminar",
    type: "past",
    tag: "Seminar",
    date: "15 October 2025",
    place: "Chandigarh, Punjab",
    text: "Pre-Rabi season seminar addressing fertilizer availability, seed quality, credit access, and crop insurance. Jointly organized with state agriculture departments of Punjab and Haryana.",
    highlight: "Attended by 400+ progressive farmers | Real-time resolution of 50+ input-related grievances"
  },
  {
    title: "International Millet Year Celebration",
    type: "past",
    tag: "Festival",
    date: "5-7 November 2025",
    place: "Chennai, Tamil Nadu",
    text: "Three-day millet festival celebrating the International Year of Millets featuring cooking competitions, buyer-seller meets, recipe launches, and B2B networking for millet-based startups.",
    highlight: "200+ millet-based products launched | Export orders worth ₹75 Crore finalized"
  },
  {
    title: "Agri-Credit & Insurance Conclave",
    type: "past",
    tag: "Conclave",
    date: "10 December 2025",
    place: "Mumbai, Maharashtra",
    text: "Focused on expanding agri-credit outreach, innovative insurance products, and reducing the protection gap for farmers. Participation from SBI, NABARD, agriculture insurance companies, and fintech firms.",
    highlight: "New insurance product for horticulture crops announced | 5 lakh farmers to benefit"
  },
  {
    title: "Cold Chain & Logistics Summit",
    type: "past",
    tag: "Summit",
    date: "20-21 January 2025",
    place: "Gurugram, Haryana",
    text: "India's largest cold chain summit addressing post-harvest losses, cold storage infrastructure gaps, and last-mile connectivity. Featured technology showcase by 60+ companies.",
    highlight: "White paper on reducing post-harvest losses from 16% to 5% released"
  },
  {
    title: "Biofuels & Agri-Waste to Wealth Forum",
    type: "past",
    tag: "Forum",
    date: "15-16 February 2025",
    place: "Pune, Maharashtra",
    text: "Exploring opportunities in ethanol blending, compressed biogas, and converting agricultural residue into valuable products. Sessions on stubble management and carbon credit markets.",
    highlight: "Roadmap for ethanol blending targets (20% by 2025) discussed with oil marketing companies"
  },
  {
    title: "Women in Agriculture Leadership Summit",
    type: "past",
    tag: "Summit",
    date: "8 March 2025",
    place: "Ahmedabad, Gujarat",
    text: "International Women's Day special summit celebrating women agripreneurs, farmers, and scientists. Featured success stories, mentorship sessions, and launch of 'Women Agri-Leaders Network'.",
    highlight: "500+ women agripreneurs participated | 20 women-led startups received funding commitments"
  },
  {
    title: "Horticulture Export Summit",
    type: "past",
    tag: "Summit",
    date: "25-26 April 2025",
    place: "Nashik, Maharashtra",
    text: "Focused on grapes, pomegranate, banana, and mango exports. Covered export protocols, packaging standards, traceability, and compliance with EU and Middle East market requirements.",
    highlight: "APEDA announced new export facilitation center for grape growers"
  },
  {
    title: "Agri-Fintech Innovation Forum",
    type: "past",
    tag: "Forum",
    date: "18 May 2025",
    place: "Bengaluru, Karnataka",
    text: "Bringing together agri-fintech startups, banks, NBFCs, and regulators to discuss digital lending, warehouse receipt financing, and blockchain for agri supply chains.",
    highlight: "Launch of 'Agri-Fintech Sandbox' by ASSOCHAM in partnership with RBI Innovation Hub"
  },
  {
    title: "Dairy & Livestock Development Conclave",
    type: "past",
    tag: "Conclave",
    date: "15-16 July 2025",
    place: "Anand, Gujarat",
    text: "Two-day conclave in India's dairy capital covering breed improvement, animal nutrition, digital solutions for dairy cooperatives, and export opportunities for value-added dairy products.",
    highlight: "Memorandum signed with NDDB for digital transformation of 1000 village cooperatives"
  }
];



/* ------------------------------- HELPERS ------------------------------- */

export function formatPressDate(iso) {
  const d = new Date(`${iso}T00:00:00`);
  if (Number.isNaN(d.getTime())) return iso;
  const month = d.toLocaleString("en-US", { month: "long" }).toUpperCase();
  return `${d.getDate()} ${month} ${d.getFullYear()}`;
}
